var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Card } from './Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faCheckCircle, faExclamationTriangle, faTimesCircle, } from '@fortawesome/pro-solid-svg-icons';
import { IconButton } from './IconButton';
import { CrossIcon } from './icons/CrossIcon';
import { Clickable } from './Clickable';
import { CaretCollapse } from './CaretCollapse';
import { useThemeStyle, getThemeKeyNames } from '../hooks/useThemeStyle';
var icons = {
    success: faCheckCircle,
    warning: faExclamationTriangle,
    danger: faTimesCircle,
};
export var Toast = function (_a) {
    var _b = _a.dismissable, dismissable = _b === void 0 ? true : _b, title = _a.title, icon = _a.icon, onClose = _a.onClose, onClick = _a.onClick, children = _a.children, _c = _a.variant, variant = _c === void 0 ? 'secondary' : _c, details = _a.details, props = __rest(_a, ["dismissable", "title", "icon", "onClose", "onClick", "children", "variant", "details"]);
    var css = useThemeStyle.apply(void 0, __spreadArray(__spreadArray([], getThemeKeyNames({ variant: variant }, 'toasts'), false), [{
            p: 2,
            borderLeftWidth: 3,
            width: 250,
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
        }], false));
    return (jsx(Card, __assign({ as: Clickable }, props, { onClick: onClick, css: css }),
        icon !== null && (jsx("div", { className: "icon", sx: {
                fontSize: '1.2rem',
                width: '1.2rem',
                mr: 3,
                ml: 1,
                mt: 2,
            } }, icon ? (icon) : (jsx(FontAwesomeIcon, { icon: icons[variant] || faInfoCircle })))),
        jsx("div", null,
            title && (jsx("div", { className: "title", sx: { fontWeight: 'bold' } }, title)),
            jsx("div", { className: "message" },
                children,
                details && (jsx(CaretCollapse, { title: "Details", sx: { mt: 2 } }, details)))),
        dismissable && (jsx("div", { sx: { position: 'absolute', right: 1, top: 1 } },
            jsx(IconButton, { onClick: onClose &&
                    (function (e) {
                        e.stopPropagation();
                        onClose();
                    }) },
                jsx(CrossIcon, null))))));
};
//# sourceMappingURL=Toast.js.map